import React, { useEffect, useState } from 'react';
import { adminGetConciergeLog } from '../../lib/api';
import { Sparkles, RefreshCw, ChevronDown, ChevronUp, BookOpen, Store } from 'lucide-react';

const SCOPES = [
  { key: 'all', label: 'All' },
  { key: 'library', label: 'Library guides' },
  { key: 'customer', label: 'Storefront' },
];

export default function ConciergeLogPanel() {
  const [scope, setScope] = useState('all');
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openId, setOpenId] = useState('');

  const load = (s = scope) => {
    setLoading(true);
    adminGetConciergeLog(s).then((d) => setSessions(d.sessions || [])).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { load(scope); }, [scope]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="max-w-4xl" data-testid="concierge-log-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-1">
        <h3 className="font-serif text-xl text-alp-cream flex items-center gap-2"><Sparkles size={18} className="text-alp-gold" /> Concierge Chat Log</h3>
        <button onClick={() => load()} data-testid="concierge-log-refresh" className="inline-flex items-center gap-2 text-[11px] tracking-[0.12em] uppercase border border-alp-line text-alp-gray px-3 py-1.5 rounded hover:text-alp-gold hover:border-alp-gold/50 transition-colors">
          <RefreshCw size={12} className={loading ? 'animate-spin' : ''} /> Refresh
        </button>
      </div>
      <p className="text-alp-gray text-sm mb-4">What members ask the library guides and the storefront concierge &mdash; your best signal for what content to add next.</p>

      <div className="flex gap-2 mb-5">
        {SCOPES.map((s) => (
          <button key={s.key} onClick={() => setScope(s.key)} data-testid={`concierge-log-scope-${s.key}`}
            className={`px-4 py-1.5 rounded-full text-xs uppercase tracking-[0.1em] border transition-colors ${scope === s.key ? 'bg-alp-gold text-alp-black border-alp-gold font-semibold' : 'border-alp-line text-alp-gray hover:border-alp-gold/60'}`}>
            {s.label}
          </button>
        ))}
      </div>

      {sessions.length === 0 ? (
        <p className="text-alp-gray text-sm py-10 text-center border border-alp-line rounded-lg" data-testid="concierge-log-empty">
          {loading ? 'Loading conversations…' : 'No conversations yet — they appear here as members chat with the concierge.'}
        </p>
      ) : (
        <div className="space-y-2">
          {sessions.map((s) => {
            const open = openId === s.sessionId;
            const isLib = s.scope === 'library';
            return (
              <div key={s.sessionId} className="border border-alp-line/70 rounded-lg bg-alp-card/40 overflow-hidden" data-testid={`concierge-session-${s.sessionId}`}>
                <button onClick={() => setOpenId(open ? '' : s.sessionId)} data-testid={`concierge-session-toggle-${s.sessionId}`} className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-alp-dark/40 transition-colors">
                  <span className={`shrink-0 inline-flex items-center gap-1.5 text-[10px] tracking-[0.12em] uppercase px-2 py-1 rounded border ${isLib ? 'text-alp-gold border-alp-gold/40' : 'text-sky-300 border-sky-400/40'}`}>
                    {isLib ? <BookOpen size={11} /> : <Store size={11} />} {isLib ? 'Library' : 'Storefront'}
                  </span>
                  <span className="flex-1 min-w-0 text-alp-cream text-sm truncate">{s.firstQuestion || '(no question)'}</span>
                  <span className="shrink-0 text-alp-gray text-[11px]">{s.questionCount} q &middot; {s.lastAt ? new Date(s.lastAt).toLocaleDateString('en-AU', { day: 'numeric', month: 'short' }) : ''}</span>
                  {open ? <ChevronUp size={15} className="text-alp-gray shrink-0" /> : <ChevronDown size={15} className="text-alp-gray shrink-0" />}
                </button>
                {open && (
                  <div className="border-t border-alp-line/60 px-4 py-4 space-y-2.5 max-h-96 overflow-y-auto" data-testid={`concierge-transcript-${s.sessionId}`}>
                    {s.messages.map((m, i) => (
                      <div key={i} className={`flex ${m.role === 'user' ? 'justify-end' : 'justify-start'}`}>
                        <div className={`max-w-[85%] rounded-lg px-3.5 py-2 text-xs leading-relaxed whitespace-pre-wrap ${m.role === 'user' ? 'bg-alp-gold/90 text-alp-black' : 'bg-alp-dark/70 border border-alp-line/60 text-alp-cream/85'}`}>
                          {m.text}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
